import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor( private route: ActivatedRoute ) { }

  isOperatorNotFound: boolean = false;

  ngOnInit() {
    console.log("is op not found", this.route.snapshot.paramMap.get('op'));
    if(this.route.snapshot.paramMap.get('op') === '0'){
      this.isOperatorNotFound = true;
    }
  }

}
